import api from './api';

// Role -> Cost Centre / GL Account access management.
export const roleAccessService = {
  getCostCenters: async () => (await api.get('/role-access/cost-centers')).data,
  getGlAccounts: async () => (await api.get('/role-access/gl-accounts')).data,
  getModules: async () => (await api.get('/role-access/modules')).data,
  // Reporting sections — the unit of access for MOD_10_REPORT. Unlike GL
  // accounts and cost centres, where no grants means UNRESTRICTED, no grants
  // here means NOTHING: reporting is opt-in.
  getReportSections: async () => (await api.get('/role-access/report-sections')).data,
  getRoleAccess: async (urid) => (await api.get(`/role-access/role/${urid}`)).data,
  getRoleModules: async (urid) => (await api.get(`/role-access/role/${urid}/modules`)).data,

  addCostCenter: (urid, code) => api.post('/role-access/cost-center', { urid, code }),
  removeCostCenter: (urid, code) => api.delete('/role-access/cost-center', { data: { urid, code } }),
  addGlAccount: (urid, code) => api.post('/role-access/gl-account', { urid, code }),
  removeGlAccount: (urid, code) => api.delete('/role-access/gl-account', { data: { urid, code } }),

  addModule: (urid, code) => api.post('/role-access/module', { urid, code }),
  removeModule: (urid, code) => api.delete('/role-access/module', { data: { urid, code } }),

  addReportSection: (urid, code) => api.post('/role-access/report-section', { urid, code }),
  removeReportSection: (urid, code) => api.delete('/role-access/report-section', { data: { urid, code } }),

  // action: 'add' | 'remove'
  bulkCostCenters: (urid, codes, action) => api.post('/role-access/cost-centers/bulk', { urid, codes, action }),
  bulkGlAccounts: (urid, codes, action) => api.post('/role-access/gl-accounts/bulk', { urid, codes, action }),
  bulkModules: (urid, codes, action) => api.post('/role-access/modules/bulk', { urid, codes, action }),
  bulkReportSections: (urid, codes, action) => api.post('/role-access/report-sections/bulk', { urid, codes, action }),
};

export default roleAccessService;
